/*
 * Cart drawer Cart / Offers tabs.
 *
 * Adds a bottom tab bar to the cart drawer that switches between the normal
 * cart view and an "Offers" view. The Offers view lists active promotions:
 *   - Free shipping progress ("Add X more to get free shipping ...").
 *   - The mystery gift, but ONLY while it is actually in stock.
 *
 * The offer copy is not re-derived here from raw settings. Instead it reads
 * the live <cart-progress-bar> custom element that already lives in the
 * drawer -- reusing its converted thresholds (bar.shippingThreshold /
 * bar.giftThreshold), its qualifying subtotal (bar.qualifyingSubtotal), its
 * in-stock flag (bar.giftAvailable) and its currency-aware formatter
 * (bar.getFormattedPrice). That keeps the Offers numbers byte-for-byte in
 * sync with the progress bar, including multi-currency conversion, and means
 * they update whenever the cart (and therefore the progress bar) refreshes.
 */
(function () {
  function q(sel, root) {
    return (root || document).querySelector(sel);
  }

  function updateOffers() {
    var bar = q('cart-progress-bar');
    var shipText = q('[data-offer-shipping-text]');
    var giftCard = q('[data-offer="gift"]');
    var giftText = q('[data-offer-gift-text]');
    var emptyMsg = q('[data-offers-empty]');

    var visibleOffers = 0;

    if (bar && typeof bar.getFormattedPrice === 'function') {
      if (shipText) {
        var shipRemain = bar.shippingThreshold - bar.qualifyingSubtotal;
        if (shipRemain <= 0) {
          shipText.textContent = "You've unlocked free shipping on this order!";
        } else {
          shipText.textContent = 'Add ' + bar.getFormattedPrice(shipRemain) + ' more to get free shipping on this order';
        }
        var shipCard = shipText.closest('[data-offer="shipping"]');
        if (shipCard) visibleOffers += 1;
      }

      if (giftCard && giftText) {
        if (bar.giftAvailable) {
          giftCard.hidden = false;
          var label = (bar.giftLabel || 'free gift').toLowerCase();
          var giftRemain = bar.giftThreshold - bar.qualifyingSubtotal;
          if (giftRemain <= 0) {
            giftText.textContent = "You've unlocked your " + label + ' on this order!';
          } else {
            giftText.textContent = 'Add ' + bar.getFormattedPrice(giftRemain) + ' more to get your ' + label + ' on this order';
          }
          visibleOffers += 1;
        } else {
          giftCard.hidden = true;
        }
      }
    } else {
      // No progress bar on the page (shipping bar disabled): still count any
      // statically-visible gift card.
      if (giftCard && !giftCard.hidden) visibleOffers += 1;
      if (shipText && shipText.closest('[data-offer="shipping"]')) visibleOffers += 1;
    }

    if (emptyMsg) emptyMsg.hidden = visibleOffers > 0;
  }

  function initTabs() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer || drawer.dataset.tabsInit === 'true') return;
    drawer.dataset.tabsInit = 'true';

    var tabs = drawer.querySelectorAll('[data-cart-tab]');
    var titleEl = q('[data-cart-title]', drawer);
    var savedCartTitle = titleEl ? titleEl.innerHTML : '';

    function setTab(name) {
      drawer.dataset.activeTab = name;
      tabs.forEach(function (t) {
        var active = t.dataset.cartTab === name;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      if (titleEl) {
        if (name === 'offers') {
          titleEl.textContent = 'Offers';
        } else {
          titleEl.innerHTML = savedCartTitle;
        }
      }

      if (name === 'offers') updateOffers();
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        setTab(t.dataset.cartTab);
      });
    });

    // The cart section refresh rewrites [data-cart-title] back to "Cart (n)".
    // Capture that fresh value as the saved cart title, and if the shopper is
    // currently on the Offers tab, re-apply the "Offers" label so it is not
    // clobbered mid-view.
    if (titleEl) {
      var obs = new MutationObserver(function () {
        if (drawer.dataset.activeTab === 'offers') {
          if (titleEl.textContent.trim() !== 'Offers') {
            savedCartTitle = titleEl.innerHTML;
            titleEl.textContent = 'Offers';
          }
        } else {
          savedCartTitle = titleEl.innerHTML;
        }
      });
      obs.observe(titleEl, { childList: true, characterData: true, subtree: true });
    }

    // Keep the Offers copy fresh: whenever the shipping-bar region re-renders
    // (any cart change refreshes it), recompute the offer messages.
    var shippingRegion = q('[data-cart-shipping-bar]', drawer);
    var watchRoot = shippingRegion ? shippingRegion.parentElement : drawer;
    if (watchRoot) {
      var offersObs = new MutationObserver(function () {
        updateOffers();
      });
      offersObs.observe(watchRoot, { childList: true, subtree: true, characterData: true });
    }

    // Reset to the Cart tab every time the drawer is opened, and refresh the
    // offer numbers so they are correct the moment the shopper taps Offers.
    var cartDrawerEl = document.querySelector('cart-drawer');
    if (cartDrawerEl) {
      var origOpen = cartDrawerEl.open;
      if (typeof origOpen === 'function') {
        cartDrawerEl.open = function () {
          var r = origOpen.apply(this, arguments);
          setTab('cart');
          updateOffers();
          return r;
        };
      }
    }

    setTab('cart');
    updateOffers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTabs);
  } else {
    initTabs();
  }
})();